// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF

import { StrategyType, UseCase } from '@tls/sw91-communication/types/com.base';
import { useEffect, useState } from 'react';

// Usecase might be used in the future for more strategy options
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getStrategyOptions = (useCase: UseCase) => {
  return [
    { id: StrategyType.SIMPLE_STRATEGY, labelKey: 'highSpeed' },
    { id: StrategyType.TWO_STEP_STRATEGY, labelKey: 'highPrecision' },
  ];
};

export default function useProjectStrategy(selectedProject) {
  const [projectStrategy, setProjectStrategy] = useState(getStrategyOptions(UseCase.COMPONENT_DETECTION)[0]);

  useEffect(() => {
    const strategyOptions = getStrategyOptions(selectedProject?.projectUseCase?.useCase ?? UseCase.COMPONENT_DETECTION);
    setProjectStrategy(strategyOptions.find(s => s.id === selectedProject?.strategyType) ?? strategyOptions[0]);
  }, [selectedProject]);

  return { projectStrategy, setProjectStrategy };
}
